import RootState from 'typings/RootState'
import { Event } from '../../../types/event'
import { Activity } from './types'

export const selectData = (state: RootState): Activity =>
  state.qcCommissChecking.data

export const selectEvent = (state: RootState): Event =>
  state.qcCommissChecking.event

export const selectSorting = (state: RootState) =>
  state.qcCommissChecking.sorting
